var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionMute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-824.000000, -1237.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Mute",
    transform: "translate(824.000000, 1237.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9999995,29 C22.105,29 22.9999995,29.8950005 22.9999995,31 L22.9999995,31 L22.9999995,32 L8.9999995,32 L8.9999995,31 C8.9999995,29.8950005 9.895,29 10.9999995,29 L10.9999995,29 L20.9999995,29 Z M27.0000005,14 C27.0000005,19.5550003 22.8570009,24.1499996 17.5000005,24.8849983 L17.5000005,27 L14.4999995,27 L14.4999995,24.8849983 C13.6149068,24.7635612 12.7629542,24.5367508 11.9573512,24.2176513 L14.3488507,21.8286514 C14.8818125,21.940937 15.4341426,22 15.9999995,22 C20.4109998,22 24.0000005,18.4109993 24.0000005,14 L27.0000005,14 Z M25.712727,5.1578183 L27.0363621,6.48 L6.524363,26.9687271 L5.2225451,25.6669083 L25.712727,5.1578183 Z M8,14 C8,15.7498817 8.5648284,17.3703995 9.5217347,18.6888008 L7.3872576,20.8277588 C5.8935432,18.9525318 5,16.5797901 5,14 L8,14 Z M21.9970383,14.190341 C21.8965363,17.4162388 19.2503152,20 15.9999995,20 L16.1825452,19.9941826 L21.9970383,14.190341 Z M15.9999995,0 L16.2994847,0.0073423 C19.4743199,0.1633646 21.9999995,2.7864242 21.9999995,6 L21.9999995,6 L21.9992738,6.1992726 L10.9572625,17.2528477 C10.4023051,16.394228 10.060677,15.3847866 10.0073418,14.2994852 L9.9999995,14 L9.9999995,6 C9.9999995,2.6860001 12.6860003,0 15.9999995,0 L15.9999995,0 Z",
    id: 277
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionMute);
export default __webpack_public_path__ + "static/media/navigation-and-action-mute.3e864a76.svg";
export { ForwardRef as ReactComponent };